import { CheckSquareOutlined, DeleteOutlined, HistoryOutlined, MinusSquareOutlined, SaveOutlined } from '@ant-design/icons'
import { Dropdown, Space, Tooltip } from 'antd'
import Search from 'antd/lib/input/Search'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './workspace-filter-controls.module.scss'
import { PureButton } from '../../../../../common/ui/pure-button/pure-button'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { MilestoneFilterTemplateDto } from '../../../../../entities/workflow/types/workflow.types'

type WorkspaceFilterControlsType = {
  milestoneFilterTemplates?: MilestoneFilterTemplateDto[]
  onSaveFilter: (filterName: string) => void
  onLoadFilter: (filter: MilestoneFilterTemplateDto) => void
  onDeleteFilter: (id: number) => void
  onCheckAll: () => void
  onRemoveSelection: () => void
  onSearch: (search: string) => void
}

export const WorkspaceFilterControls = ({
  milestoneFilterTemplates = [],
  onCheckAll,
  onSaveFilter,
  onLoadFilter,
  onDeleteFilter,
  onRemoveSelection,
  onSearch,
}: WorkspaceFilterControlsType) => {
  const { t } = useTranslation()
  const [templateName, setTemplateName] = useState<string>('')
  const [open, setOpen] = useState(false)
  const [templateListOpened, setTemplateListOpened] = useState(false)

  const handleOpenChange = (flag: boolean) => {
    setTemplateListOpened(false)
    setOpen(flag)
  }

  const handleOpenTemplateListChange = (flag: boolean) => {
    setOpen(false)
    setTemplateListOpened(flag)
  }

  const handleTemplateNameChange = (e: any) => {
    setTemplateName(e.target.value)
  }

  const handleSaveFilter = () => {
    if (templateName) {
      onSaveFilter(templateName)
      setOpen(false)
      setTemplateListOpened(false)
    }
  }

  const handleLoadFilter = (filter: MilestoneFilterTemplateDto) => {
    onLoadFilter(filter)
  }

  const handleDelete = (id: number) => {
    onDeleteFilter(id)
  }

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex">
        <Dropdown
          dropdownRender={() => (
            <div>
              <Space direction="horizontal">
                <PureInput
                  onChange={handleTemplateNameChange}
                  placeholder="Введите название шаблона"
                  size="small"
                  value={templateName}
                />
                <PureButton
                  onClick={handleSaveFilter}
                  type="primary"
                >
                  {t('common.save')}
                </PureButton>
              </Space>
            </div>
          )}
          onOpenChange={handleOpenChange}
          open={open}
          trigger={['click']}
        >
          <Tooltip
            open={!open ? undefined : false}
            placement="bottom"
            title={t('common.saveTemplate')}
          >
            <PureButton
              className="ps-3 pe-3"
              size="small"
              type="primary"
            >
              <SaveOutlined />
            </PureButton>
          </Tooltip>
        </Dropdown>
        <Dropdown
          dropdownRender={() => (
            <div>
              <Space
                className={styles.filterDropdown}
                direction="vertical"
              >
                {milestoneFilterTemplates.map((filterTemplate) => (
                  <div
                    key={filterTemplate.id}
                    className="d-flex justify-content-between"
                  >
                    <div
                      className={styles.templateItem}
                      onClick={() => handleLoadFilter(filterTemplate)}
                    >
                      {filterTemplate.name}
                    </div>
                    <DeleteOutlined
                      className={styles.icon}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete(filterTemplate.id)
                      }}
                    />
                  </div>
                ))}
              </Space>
            </div>
          )}
          onOpenChange={handleOpenTemplateListChange}
          open={templateListOpened}
          trigger={['click']}
        >
          <Tooltip
            open={!templateListOpened ? undefined : false}
            placement="bottom"
            title={t('common.loadTemplate')}
          >
            <PureButton
              className="ml-1 ps-3 pe-3"
              size="small"
            >
              <HistoryOutlined />
            </PureButton>
          </Tooltip>
        </Dropdown>
        <div className={clsx('ml-5')}>
          <Tooltip
            placement="bottom"
            title={t('common.checkAll')}
          >
            <PureButton
              className="ml-1 ps-3 pe-3"
              onClick={onCheckAll}
              size="small"
            >
              <CheckSquareOutlined />
            </PureButton>
          </Tooltip>
          <Tooltip
            placement="bottom"
            title={t('common.removeSelection')}
          >
            <PureButton
              className="ml-1 ps-3 pe-3"
              onClick={onRemoveSelection}
              size="small"
            >
              <MinusSquareOutlined />
            </PureButton>
          </Tooltip>
        </div>
      </div>
      <div className={clsx('d-flex align-items-center', styles.filterSearchWrapper)}>
        <div>
          <Search
            onChange={(event) => onSearch(event.target.value)}
            placeholder={t('workspace.searchMilestones')}
          />
        </div>
        {/*<div className={clsx(styles.filterSelectWrapper, 'ml-1')}>*/}
        {/*  <PureSelect*/}
        {/*    onChange={onFilterTypeChange}*/}
        {/*    options={selectionTypes}*/}
        {/*    placeholder={t('common.all')}*/}
        {/*    size="small"*/}
        {/*    value={defaultSelectionValue}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
    </div>
  )
}
